import { keyframes } from '@chakra-ui/react';

const shimmer = keyframes`
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
`;
const Skeleton = {
  baseStyle: {
    width: "100%",
    height: "96px",
    borderRadius: "button",
    background: `linear-gradient(
      290deg, 
      var(--vimeo-colors-slate-50) 10%, 
      var(--vimeo-colors-slate-100) 50%, 
      var(--vimeo-colors-slate-50) 90%)`,
    animation: `${shimmer} 3s linear infinite`,
    backgroundSize: "200%",
    _dark: {
      background: `linear-gradient(
        290deg,
        var(--vimeo-colors-grayscale-800) 10%,
        var(--vimeo-colors-grayscale-700) 50%,
        var(--vimeo-colors-grayscale-800) 90%
      )`,
      animation: `${shimmer} 3s linear infinite`,
      backgroundSize: "200%"
    }
  },
  variants: {
    text: {
      height: ".5rem",
      borderRadius: "lg"
    },
    circle: {
      borderRadius: "full",
      height: "xl",
      width: "xl"
    }
  }
};

export { Skeleton };
